import MuiButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const StyledButton = styled(MuiButton)({});
